module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "modal--small",
    attrs: {
      "show": _vm.show,
      "data-backdrop": "static",
      "clickToClose": "false",
      "data-keyboard": "false"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('i', {
    staticClass: "ti-close",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Ime vozila")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "text",
      "name": "username"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tablice")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plate),
      expression: "plate"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "text",
      "name": "password"
    },
    domProps: {
      "value": (_vm.plate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.plate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Opis")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "text",
      "name": "password"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Isticanje registracije")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registrationExpiration),
      expression: "registrationExpiration"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "text",
      "name": "password"
    },
    domProps: {
      "value": (_vm.registrationExpiration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registrationExpiration = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tip goriva")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fuel),
      expression: "fuel"
    }],
    staticClass: "form-control border-input",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fuel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "GASOLINE",
      "selected": ""
    }
  }, [_vm._v("BENZIN")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DIESEL"
    }
  }, [_vm._v("DIZEL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TNG"
    }
  }, [_vm._v("TNG")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "METHANE"
    }
  }, [_vm._v("METAN")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ELECTRIC"
    }
  }, [_vm._v("ELEKTRIČNI POGON")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "HYBRID"
    }
  }, [_vm._v("HIBRID")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Predjeni KM")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kilometersTraveled),
      expression: "kilometersTraveled"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "number",
      "name": "password"
    },
    domProps: {
      "value": (_vm.kilometersTraveled)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.kilometersTraveled = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Prosecna potrosnja")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.averageSpending),
      expression: "averageSpending"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "text",
      "name": "password"
    },
    domProps: {
      "value": (_vm.averageSpending)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.averageSpending = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Mali servis (na koliko se radi u KM)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.smallService),
      expression: "smallService"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "number",
      "name": "password"
    },
    domProps: {
      "value": (_vm.smallService)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.smallService = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Poslednji mali servis (na koliko KM je uradjen poslednji mali servis, ovo se unosi samo prvi put, posle ce samo da se popunjava)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastSmallService),
      expression: "lastSmallService"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "number",
      "name": "password"
    },
    domProps: {
      "value": (_vm.lastSmallService)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastSmallService = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasError.length !== 0),
      expression: "hasError.length !== 0"
    }],
    staticClass: "foo"
  }, [_c('div', [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.hasError))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [(!_vm.isLoading) ? _c('input', {
    staticClass: "input",
    staticStyle: {
      "background": "#2b542c"
    },
    attrs: {
      "type": "button",
      "placeholder": _vm.buttonTitle,
      "name": "azuriraj",
      "value": _vm.buttonTitle
    },
    on: {
      "click": function($event) {
        return _vm.addVehicle()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "foo"
  }, [_c('div', {
    staticClass: "loader",
    staticStyle: {
      "width": "36px",
      "height": "36px"
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e641487!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/AddVehicleModal.vue
// module id = 493
// module chunks = 1